import type { SubscriptionTableColumn } from "./types";

interface TableHeaderProps {
    columns: SubscriptionTableColumn[];
}

const TableHeader = ({ columns }: TableHeaderProps) => {
    return (
        <thead>
            <tr>
                {columns.map((column, index) => {
                    const isFirst = index === 0;
                    const isLast = index === columns.length - 1;
                    const paddingLeft = isFirst ? "16px" : "8px";
                    const paddingRight = isLast ? "16px" : "8px";

                    return (
                        <th
                            key={column.id}
                            style={{
                                width: column.width,
                                textAlign: column.align || "center",
                                verticalAlign: "middle",
                                backgroundColor: "#F6F6F6",
                                padding: `12px ${paddingRight} 12px ${paddingLeft}`,
                                fontSize: "11px",
                                fontWeight: 600,
                                color: "#676767",
                                borderBottom: "1px solid #eaeaea",
                                wordBreak: "normal",
                                whiteSpace: "normal",
                                lineHeight: "1.3",
                            }}
                        >
                            {column.label}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

export default TableHeader;
